import * as yup from 'yup'

export const editNewsValidation = yup.object().shape({
  title: yup.string().required('Title is required'),
  description: yup.string().required('Description is required')
})

export const addNewsValidation = yup.object().shape({
  title: yup.string().required('Title is required'),
  description: yup.string().required('Description is required'),
  image: yup
    .mixed()
    .required('Image is required')
    .test('fileExist', 'Image is required', value => {
      return value && value.length > 0
    })
    .test('fileType', 'Only image files are allowed', value => {
      if (!value?.length) return false
      return ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'].includes(
        value[0]?.type
      )
    })
    .test('fileSize', 'File is too large', value => {
      if (!value?.length) return false
      return value[0]?.size <= 5 * 1024 * 1024 // 5MB
    }),
  logo: yup
    .mixed()
    .test('fileSize', 'File is too large', value => {
      return !value || (value[0] && value[0].size <= 5000000) // 5MB limit
    })
    .test('fileType', 'Unsupported file type', value => {
      return (
        !value ||
        (value[0] &&
          ['image/jpeg', 'image/png', 'image/svg+xml'].includes(value[0].type))
      )
    })
})
